import {GET, POST} from '../../index'
// 获取游戏列表
export const getGamePage = (data) => {
  return GET('/language/game/page', data)
}

// 更新指定状态
export const changeInfo = (data) => {
  return POST('/language/game/change', data)
}

// 保存游戏
export const storeGame = (data) => {
  return POST('/language/game/store', data)
}

// 更改排序/状态
export const storeSort = (data) => {
  return POST('/language/game/change', data)
}

// 获取基本数据
export const getInfo = (data) => {
  return GET('/language/game/info', data)
}

// 上架游戏列表
export const getShelvesGame = (data) => {
  return GET('/language/game/shelves', data)
}

// 获取所有渠道
export const channels = (data) => {
  return GET('/language/channel/all', data)
}
// 保存渠道
export const storeChannel = (data) => {
  return POST('/language/channel/store', data)
}

// 获取所有渠道链接
export const links = (data) => {
  return GET('/language/game/link/all', data)
}

// 保存渠道链接
export const storeGameLink = (data) => {
  return POST('/language/game/link/store', data)
}

// 渠道链接更改排序/状态
export const storeLinkSort = (data) => {
  return POST('/language/game/link/change', data)
}



// WEBPACK FOOTER //
// ./src/api/language/game/index.js